import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  ProdutoCadastroDto,
  ProdutoCadastroSchema,
} from "./ProdutoCadastro.Dto";
import { useToast } from "src/componentes";
import {
  ProdutoAtualizar,
  ProdutoBuscarPorId,
  ProdutoIncluir,
} from "src/services/Estoque.Service";
import {
  criarMenuItem,
  filtrarRotasPorRotaAtual,
  FormatarPontoVirgula,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import { MenuItemDto } from "src/pages/Privada/Menu/MenuItem.Dto";

const ProdutoCadastroCode = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const dupId = searchParams.get("dupid");
  const { showToast } = useToast();
  const [menuItens, setMenuItens] = useState<MenuItemDto[]>([]);
  const location = useLocation();
  const isDuplicate = dupId && true;

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          carregarProduto(id);
          setIncluir(false);
          carregarRotas();
        } else if (dupId) {
          setLoading(true);
          carregarProduto(dupId);
          setIncluir(true);
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const carregarProduto = async (id: string) => {
    const response = await ProdutoBuscarPorId(id);
    if (response.data.success) {
      const data = response.data.data as ProdutoCadastroDto;
      data.valorUnitarioComercial = FormatarPontoVirgula(
        data.valorUnitarioComercial
      );
      reset(data);
    } else {
      showToast({
        message: "Ocorreu erro ao carregar produto",
        title: "Erro",
        variant: "Danger",
      });
    }
  };

  const carregarRotas = () => {
    const rotas = filtrarRotasPorRotaAtual(location.pathname);
    rotas.push(
      criarMenuItem("Duplicar", `/estoque/produtos/cadastro?dupid=${id}`)
    );
    setMenuItens(rotas);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<ProdutoCadastroDto>({
    resolver: yupResolver(ProdutoCadastroSchema),
  });

  const onSubmit = async (data: ProdutoCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    if (incluir === true) {
      ProdutoIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/estoque/produtos");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            showToast({
              message: "Ocorreu erro ao incluir cadastro",
              title: "Erro",
              variant: "Danger",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      ProdutoAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/estoque/produtos");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            showToast({
              message: "Ocorreu erro ao atualizar cadastro",
              title: "Erro",
              variant: "Danger",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  return {
    loading,
    onSubmit,
    handleSubmit,
    errors,
    register,
    setValue,
    menuItens,
    handleClickNavigate,
    isDuplicate,
  };
};

export default ProdutoCadastroCode;
